import React, { useEffect, useState } from 'react'
import './style.scss'
import DateBlueIcon from '../../icons/DateBlueIcon'
import GreenArrowUpIcon from '../../icons/GreenArrowUpIcon'
import ArrowRedBottomIcon from '../../icons/ArrowRedBottomIcon'
import CalendarBlueCircleIcon from '../../icons/CalendarBlueCircleIcon'
import PoundCircleIcon from '../../icons/PoundCircleIcon'
import SearchIcon from '../../icons/SearchIcon'
import { Button, Dropdown, Modal, Table } from 'react-bootstrap'
import FilterIcon from '../../icons/FilterIcon'
import DeleteRedIcon from '../../icons/DeleteRedIcon'
import { getDashboardData } from '../../services/dashboard.service'
import BusinessIcon from '../../icons/BusinessIcon'
import CalendarIcon from '../../icons/CalendarIcon'
import { cancelBooking, getBookingDetails } from '../../services/bookings.service'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { all_routes } from '../router/all_routes'
import { AxiosError } from 'axios'
import { CommonPagination } from '../../core/components/common/CommnPagination'
import { formatBookingTime } from '../../utils'

export default function Dashboard() {
  const [show, setShow] = useState(false);
  const locationId = localStorage.getItem('locationId');
  const [currentPage, setCurrentPage] = useState<number>(1);  // Track current page
  const [totalItems, setTotalItems] = useState<number>(0);  // Track total number of items
  const itemsPerPage = 10; // Number of items per page
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [filterOption, setFilterOption] = useState<string>('newToOld');
  const [dashboardData, setDashboardData] = useState<any>({});
  const [selectedBooking, setSelectedBooking] = useState<any>(null); // To hold selected booking details
  const navigate = useNavigate();
  const route = all_routes;
  const [deleteModalShow, setDeleteModalShow] = useState(false);

  useEffect(() => {
    getDashboardlist(currentPage, searchTerm, filterOption);
  }, [currentPage, searchTerm, filterOption]);

  const getDashboardlist = async (page: number, searchTerm: string, filterOption: string,) => {
    if (!locationId) return;
    let skip = (page - 1) * itemsPerPage;

    try {
      const payload = {
        search: searchTerm,
        sortOrder: filterOption,
        skip,
        limit: itemsPerPage,
      };
      const result: any = await getDashboardData(locationId, payload);
      setDashboardData(result?.data?.data || {});
      setTotalItems(result?.data?.totalRecord || 0)
    } catch (error) {
      console.error(error);
    }
  };

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  // Update filter option state
  const handleFilterChange = (filter: string) => {
    setFilterOption(filter);
    setCurrentPage(1);  // Reset to page 1 when filter changes

    getDashboardlist(currentPage, searchTerm, filter);
  };

  // Using centralized date formatting utility

  const handleShow = async (bookingId: string) => {
    setShow(true);

    try {
      const result = await getBookingDetails(bookingId);
      setSelectedBooking(result?.data?.data || null);
    } catch (error) {
      console.error("Failed to fetch booking details:", error);
      setSelectedBooking(null);
    }
  };

  const handleClose = () => {
    setShow(false);
    setSelectedBooking(null);
  };

  const handleCheckIn = async (bookingId: string | undefined) => {
    if (!bookingId) return;
    try {
      navigate(route.checkIn);
    } catch (error) {
      toast.error("Check-in was unsuccessful. Please try again or contact support if the issue persists")
    }
  };

  const handleCancel = async (bookingId: string | undefined) => {
    if (!bookingId) return;
    try {
      setShow(false);
      setDeleteModalShow(true);
      getDashboardlist(currentPage, searchTerm, filterOption);
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data?.responseMessage)
      }
    }
  };

  const handleDeleteClose = () => {
    setDeleteModalShow(false);
  };

  const handleDeleteConfirm = async (bookingId: string | undefined) => {
    if (!bookingId) return;
    try {
      const result = await cancelBooking(bookingId);

      if (result?.data?.responseCode === 404) {
        toast.error(result?.data?.responseMessage)
      }
      else {
        toast.success(result?.data?.responseMessage);
      }

      setDeleteModalShow(false);
      setSelectedBooking(null);
      setShow(false);
      getDashboardlist(currentPage, searchTerm, filterOption);
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data?.responseMessage)
      }
    }
  }


  return (
    <>
      <div className='dashboardPage'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <h1 className='mt-3 pageTitle'>Dashboard</h1>
            </div>
          </div>

          <div className='row blocks'>
            <div className='col-lg-4 col-md-12 col-sm-12 mb-3'>
              <div className='card'>
                <div className='d-flex justify-content-between align-items-center'>
                  <span>Today’s booking</span>
                  <DateBlueIcon />
                </div>
                <h2>{dashboardData?.todayBooking?.todayCounts}</h2>
                <div className='d-flex justify-content-between align-items-center'>
                  <label>No-shows: {dashboardData?.todayBooking?.noShowCount}</label>
                  <label>Yesterday: {dashboardData?.todayBooking?.yesterdayCounts}
                    {dashboardData?.todayBooking?.todayCounts > dashboardData?.todayBooking?.yesterdayCounts ? (
                      <GreenArrowUpIcon />
                    ) : (
                      <ArrowRedBottomIcon />
                    )}
                  </label>
                </div>
              </div>
            </div>

            <div className='col-lg-4 col-md-12 col-sm-12 mb-3'>
              <div className='card'>
                <div className='d-flex justify-content-between align-items-center'>
                  <span>Monthly booking</span>
                  <CalendarBlueCircleIcon />
                </div>
                <h2>{dashboardData?.monthBooking?.currentMonthCounts}</h2>
                <div className='d-flex justify-content-between align-items-center'>
                  <label>No-shows: {dashboardData?.monthBooking?.noShowCount}</label>
                  <label>Last month: {dashboardData?.monthBooking?.lastMonthCounts}
                    {dashboardData?.monthBooking?.currentMonthCounts > dashboardData?.monthBooking?.lastMonthCounts ? (
                      <GreenArrowUpIcon />
                    ) : (
                      <ArrowRedBottomIcon />
                    )}
                  </label>
                </div>
              </div>
            </div>

            <div className='col-lg-4 col-md-12 col-sm-12 mb-3'>
              <div className='card'>
                <div className='d-flex justify-content-between align-items-center'>
                  <span>{dashboardData?.revenueData?.type?.toLowerCase() === 'month' ? "Monthly revenue" : "Current month revenue"} </span>
                  <PoundCircleIcon />
                </div>
                <h2>LE {dashboardData?.revenueData?.currentMonth}</h2>

                {dashboardData?.revenueData?.type?.toLowerCase() !== 'month' && (
                  <div className='d-flex justify-content-between align-items-center'>
                    <label>Today’s revenue: LE {dashboardData?.revenueData?.today}</label>
                    <label>Last month: LE {dashboardData?.revenueData?.lastMonth}
                      {dashboardData?.revenueData?.currentMonth > dashboardData?.revenueData?.lastMonth ? (
                        <GreenArrowUpIcon />
                      ) : (
                        <ArrowRedBottomIcon />
                      )}
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="bgFormColor p-4 my-4">
            <div className="searchTitleWrap d-flex justify-content-between align-items-start">
              <label>Upcoming booking</label>
              <div className="searchWrap d-flex gap-2 align-items-center">
                <form>
                  <button>
                    <SearchIcon />
                  </button>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search booking ..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                </form>

                <div className="filterDropdown">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      <FilterIcon />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <button
                        className={filterOption === 'newToOld' ? 'active' : ''}
                        onClick={() => handleFilterChange('newToOld')}
                      >
                        Date, new to old
                      </button>
                      <button
                        className={filterOption === 'oldToNew' ? 'active' : ''}
                        onClick={() => handleFilterChange('oldToNew')}
                      >
                        Date, old to new
                      </button>
                      <button
                        className={filterOption === 'aToZ' ? 'active' : ''}
                        onClick={() => handleFilterChange('aToZ')}
                      >
                        Alphabetically, A-Z
                      </button>
                      <button
                        className={filterOption === 'zToA' ? 'active' : ''}
                        onClick={() => handleFilterChange('zToA')}
                      >
                        Alphabetically, Z-A
                      </button>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <Table className="tableWrapper">
                <thead>
                  <tr>
                    <th>Class name</th>
                    <th>Booking date time</th>
                    <th>Visitor Name</th>
                    <th>Status / Action</th>
                  </tr>
                </thead>

                <tbody>
                  {dashboardData?.upcommingBookings?.length > 0 ? (
                    dashboardData?.upcommingBookings.map((booking: any, index: any) => (
                      <tr>
                        <td>
                          <span className="underline">
                            {booking?.className.charAt(0).toUpperCase() + booking?.className.slice(1)}
                          </span>
                        </td>
                        <td>
                          {booking?.bookingStartDateTime ? formatBookingTime(booking?.bookingStartDateTime) : "-"}
                        </td>
                        <td>
                          {`${booking?.employeeFirstname.charAt(0).toUpperCase() + booking?.employeeFirstname.slice(1)} ${booking?.employeeLastname.charAt(0).toUpperCase() + booking?.employeeLastname.slice(1)}`}
                        </td>
                        <td>
                          <div className="d-flex gap-2 align-items-center">
                            <span
                              className='text-success'
                            >
                              {booking?.status.charAt(0).toUpperCase() + booking?.status.slice(1)}
                            </span>
                            <button
                              onClick={() => handleShow(booking?._id)}
                              className="confirmBtn">
                              Details
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={5} className="text-center">
                        No booking's found.
                      </td>
                    </tr>
                  )}
                </tbody>

              </Table>

              <div className="paginationWrapper">
                <CommonPagination
                  totalRecords={totalItems}
                  recordsPerPage={itemsPerPage}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>


      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
        className="confirmModal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Booking</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedBooking ? (
            <div>
              <div className="modalImg">
                <img className="w-100" src={"/assets/img/modalImage.jpg"} alt="modalImage" />
              </div>
              <div className="game_content">
                <label>
                  <BusinessIcon /> {" "}
                  <span className="underline">
                    {selectedBooking?.partnerDetails?.businessName ? selectedBooking?.partnerDetails?.businessName : selectedBooking?.partnerDetails?.name}
                  </span>
                </label>
                <h2>{selectedBooking?.className.charAt(0).toUpperCase() + selectedBooking?.className.slice(1)}
                </h2>
                <label className="dateWrap">
                  <CalendarIcon />
                  {selectedBooking?.bookingStartDateTime ? formatBookingTime(selectedBooking?.bookingStartDateTime) : "-"}
                </label>
                <div className="bgFormColor p-4 my-3">
                  <h3>Booking person details</h3>
                  <div className="bookDetail">
                    <ul>
                      <li className="d-flex justify-content-between"><label>Full name :</label>
                        <h4> {`${selectedBooking?.employeeDetails?.firstName.charAt(0).toUpperCase() + selectedBooking?.employeeDetails?.firstName.slice(1)} ${selectedBooking?.employeeDetails?.lastName.charAt(0).toUpperCase() + selectedBooking?.employeeDetails?.lastName.slice(1)}`}</h4>
                      </li>
                      <li className="d-flex justify-content-between"><label>Email id :</label><h4> {selectedBooking?.employeeDetails?.email}</h4></li>
                      <li className="d-flex justify-content-between"><label>Contact :</label><h4>{selectedBooking?.employeeDetails?.phone}</h4></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <p>Loading booking details...</p>
          )}
        </Modal.Body>

        <Modal.Footer className="w-100 direction-column justify-content-center">
          {selectedBooking?.status?.toLowerCase() !== "cancelled" && selectedBooking?.status?.toLowerCase() !== "checked-in" &&
            selectedBooking?.status?.toLowerCase() !== "late cancelled"
            && (
              <div>
                <Button onClick={() => handleCheckIn(selectedBooking?._id)} className="w-100 mb-2">Check-in</Button>

                {/* Calculate if cancel button should be shown */}
                {
                  new Date(selectedBooking?.bookingStartDateTime) > new Date(Date.now() + 60 * 60 * 1000) && (
                    <Button
                      variant="outline-danger"
                      onClick={() => handleCancel(selectedBooking?._id)}
                      className="w-100 mb-2"
                    >
                      Cancel
                    </Button>
                  )
                }

              </div>
            )}

          {selectedBooking?.status?.toLowerCase() === "cancelled" && (
            <div className="dangerCancel d-flex align-items-center border-danger border">
              <label className="mb-0 p-2">This booking has been cancelled.</label>
            </div>
          )}
        </Modal.Footer>
      </Modal>

      <Modal show={deleteModalShow} onHide={handleDeleteClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className='delete-modal'
      >
        <Modal.Body className='text-center'>
          <div className='d-flex justify-content-center align-items-center'>
            <DeleteRedIcon />
          </div>
          <h3>Confirm Deletion</h3>
          <p>Are you sure you want to delete this booking? This action cannot be undone.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline" onClick={handleDeleteClose}>Close</Button>
          <Button className='primaryButton' variant="primary" onClick={() => handleDeleteConfirm(selectedBooking?._id)}>Continue</Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
